import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FloatingButton } from "./styles";
import { EditOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useKeycloak } from "@react-keycloak/web";

const FloatingReportButton: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { keycloak } = useKeycloak();

  // Don't show the button if not authenticated
  if (!keycloak.authenticated) {
    return null;
  }

  // Check if user has the "reporter" role
  const userRoles = Array.isArray(
    keycloak?.resourceAccess?.medianestclient?.roles,
  )
    ? keycloak.resourceAccess.medianestclient.roles
    : [];

  const hasReporterRole = userRoles.includes("reporter");

  // Don't show the button if user doesn't have the reporter role
  if (!hasReporterRole) {
    return null;
  }

  // Don't show the button if already on the report-news page
  if (location.pathname === "/report-news") {
    return null;
  }

  const handleClick = () => {
    navigate("/report-news");
  };

  return (
    <Tooltip title="Report News" placement="left">
      <FloatingButton
        type="primary"
        icon={<EditOutlined style={{ fontSize: "24px" }} />}
        onClick={handleClick}
      />
    </Tooltip>
  );
};

export default FloatingReportButton;
